import axios from './api';

export default {
  getAllUsers() {
    return axios.get('/api/user').then((res) => res.data);
  },
  getUsers(page, q) {
    if (q) {
      return axios.get(`/api/user/?page=${page}&query=${q}`).then((res) => res.data);
    } else {
      return axios.get(`/api/user/?page=${page}`).then((res) => res.data);
    }
  },
  getUsersById(id) {
    return axios.get(`/api/user/${id}`).then((res) => res.data);
  },
  createUser(user) {
    return axios.post('/api/user', user).then((res) => res.data);
  },
  removeUser(id) {
    return axios.delete(`/api/user/${id}`).then((res) => res.data);
  },
  updateUser(user) {
    return axios.put(`/api/user/me`, user).then((res) => res.data);
  },
  updatePassword(passwords) {
    return axios.put(`/api/user/me/password`, passwords).then((res) => res.data);
  },
  updateUserAsAdmin(id, user) {
    return axios.put(`/api/user/${id}`, user).then((res) => res.data);
  },
  updatePasswordAsAdmin(id, password) {
    return axios.put(`/api/user/${id}/password`, password).then((res) => res.data);
  },
  signInAsUser(userId) {
    return axios.post(`/api/auth/sign-in-as`, userId).then((res) => res.data);
  },
};
